/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const TestingSection = Loadable(lazy(() => import("sections/testing")));

let testingRoutes = [
    {
        path: "testing",
        element: <TestingSection/>,
    },
    {
        path: "/testing/list",
        element: <TestingSection/>,
    },
];
export { testingRoutes };
